import {stateData, reduxState} from '../../values';

export const getChannels = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_channels,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateChannels = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_channels,
            payload:    data,
        })
    }
}